<template>
  <div style="width: 100%;">
    <el-header style="margin: 15px" >
      <breadcrumb></breadcrumb>
    </el-header>

      <el-main style="overflow-x: hidden;">
        <el-form ref="form" label-width="150px" >
          <el-row>
            <el-col :span="12">
              <el-form-item :label="$t('field.downloadType')">
                <el-select v-model="downloadType" :placeholder="$t('msg.pleaseSelect')" >
                  <el-option v-for="item in downloadTypeOpts"  :key="item.value"  :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('field.downloadTime')">
                <el-col :span="11">
                  <el-date-picker type="date" :placeholder="$t('msg.selectDate')" v-model="sdate" style="width: 100%;"></el-date-picker>
                </el-col>
                <el-col class="line" :span="2" style='text-align: center;'>-</el-col>
                <el-col :span="11">
                <el-date-picker type="date" :placeholder="$t('msg.selectDate')" v-model="edate" style="width: 100%;"></el-date-picker>
                </el-col>
              </el-form-item>
            </el-col>
            
          </el-row> 
          <el-row>
            <el-col :span="12">
              <CustomerSearch v-model="custSapCode" @sync-select-customer="syncSelectCustomer" />            
            </el-col>                             
          </el-row>   
          <el-row>
            <el-col :span="24" style="text-align:center">
              <el-button type="primary" @click="search"  size="small">{{$t('button.search')}}</el-button>
            </el-col>             
          </el-row>   
        </el-form>
        <el-row>  
          <Table  v-if="downloadType=='SWFW'" ref="table1" :tableData="tableData"  @reload-data-by-sort="reloadDataBySort" /> 
          <Table  v-else ref="table2" :tableData="tableData2"   @reload-data-by-sort="reloadDataBySort"/> 
        </el-row>
        
    </el-main>
  </div>
</template>

<script>
import Table from '../components/FuzzySearchTableWithRemoteSort'
import Breadcrumb from '../components/Breadcrumb'
import {  apiFindDownloadLogByCondition } from "../../utils/api.js";
import authHeader from "../../services/auth-header";
import CommonUtil from "../../utils/commonUtil.js";
import CustomerSearch from "../components/CustomerSearch";
  
export default {
  name: 'downloadLog',
  data() {    
    return {  
      sdate: '',
      edate: '',
      custSapCode:'',
      downloadType: 'SWFW',
      downloadTypeOpts:[{label:'軟韌體 SW/FW',value:'SWFW'},{label:'文件 DOC',value:'DOCUMENT'}],
      tableData: {
        columns: [
          { field: "downloadTime", title: this.$i18n.t('field.downloadTime'), width: 150, align:'center' },         
          { field: "custSortl", title:  this.$i18n.t('field.sortl'), width: 250 },
          { field: "account", title:  this.$i18n.t('field.account'), width: 180 },
          { field: "type", title: 'Type', width: 150  },  
          { field: "version", title: 'Version'   },
          { field: "isImportant", title: this.$i18n.t('field.isImportant'), width: 150, align:'center' },   
          { field: "completeMajorUpdateTime", title: this.$i18n.t('field.completeMajorUpdateTime'), width: 200, align:'center'}
        ],
        originalTableData:[],
        data: [],
        pagesize: 10,
        currentPage: 1,
        tableId:'custTable',
        exportName: this.$i18n.t('menu.customerFeedbackHandling')
      },
      tableData2: {
        columns: [
          { field: "downloadTime", title: this.$i18n.t('field.downloadTime'), width: 150, align:'center'},         
          { field: "custSortl", title: this.$i18n.t('field.sortl'), width: 250  },
          { field: "account", title:  this.$i18n.t('field.account'), width: 180 },
          //{ field: "model", title: 'Model', width: 150  },  
          { field: "type", title: 'Type', width: 220   },
          { field: "documentName", title: this.$i18n.t('field.documentName') }
        ],
        originalTableData:[],
        data: [],
        pagesize: 10,
        currentPage: 1,
        tableId:'custTable2',
        exportName: this.$i18n.t('menu.customerFeedbackHandling')
      },
      sortColumn:'',
      sortType:'' 
    };
  }, 
  components: {
    Breadcrumb,
    Table,
    CustomerSearch
  },
  mounted() {  
    this.edate = new Date();
    this.sdate = CommonUtil.addDays(new Date(),-180);
    this.findData();
  },
  watch:{
    downloadType(){
      this.findData();            
    }
  },
  methods: {
    findData(){      
      var sdate = '', edate = '';
      if(this.sdate != null && this.sdate != ''){        
        sdate = this.sdate.getFullYear() +''+ CommonUtil.lpad(this.sdate.getMonth()+1, 2) +''+ CommonUtil.lpad(this.sdate.getDate(), 2);
      }
       if(this.edate != null && this.edate != ''){        
        edate = this.edate.getFullYear() +''+ CommonUtil.lpad(this.edate.getMonth()+1, 2) +''+ CommonUtil.lpad(this.edate.getDate(), 2);
      } 
      apiFindDownloadLogByCondition({ headers: authHeader(), sdate : sdate, edate : edate, downloadType:this.downloadType, 
          custSapCode:this.custSapCode,sortColumn: this.sortColumn, sortType:this.sortType}).then((response) => { 

       if(this.downloadType=='SWFW'){                      
          this.tableData.data = response.data;  
          this.tableData.originalTableData =  this.tableData.data;
          this.$refs.table1.$refs.filterTable.doLayout();
        }else{      
          this.tableData2.data = response.data;  
          this.tableData2.originalTableData =  this.tableData2.data;  
          this.$refs.table2.$refs.filterTable.doLayout();
        }
            
      }).catch((err) => {
        console.log(err);
      });
    },
    search() {
      this.findData();
    },
    syncSelectCustomer(custNo){            
      this.custSapCode = custNo;     
    },
    reloadDataBySort(sortColumn, sortType){
      this.sortColumn = sortColumn;
      this.sortType = sortType;
      this.findData()
    } 
  }
};
</script>
